import * as React from 'react';
import { FieldMapper } from './fieldMapper';
export var useCustomisedFieldMapper = function useCustomisedFieldMapper(fieldMapperExtension) {
  return React.useMemo(function () {
    var _FieldMapper = new FieldMapper(fieldMapperExtension),
      fieldMapper = _FieldMapper.fieldMapper;
    return fieldMapper;
  }, [fieldMapperExtension]);
};